import type { JSX } from 'react';
import type { SortState } from '@/shared/types/table-filters.types';
import { JobPositionCard } from './JobPositionCard';
import { JobPositionTable } from './JobPositionTable';
import type { JobPosition } from '../types/jobPosition.types';

export interface JobPositionListProps {
  jobPositions: JobPosition[];
  isLoading: boolean;
  sort: SortState | null;
  onToggleSort: (key: string) => void;
  onEdit: (jobPosition: JobPosition) => void;
  onDelete: (id: string) => void;
  onArchive: (id: string, archive: boolean) => void;
  onNavigate: (jobPosition: JobPosition) => void;
}

/** Desktop table and mobile cards render the same already filtered/sorted job positions. */
export function JobPositionList({
  jobPositions,
  isLoading,
  sort,
  onToggleSort,
  ...itemHandlers
}: JobPositionListProps): JSX.Element {
  if (isLoading) {
    return <div className="text-center py-8 text-muted-foreground">Loading job positions...</div>;
  }

  if (jobPositions.length === 0) {
    return <div className="text-center py-8 text-muted-foreground">No job positions found</div>;
  }

  return (
    <>
      <div className="hidden md:block">
        <JobPositionTable
          jobPositions={jobPositions}
          sort={sort}
          onToggleSort={onToggleSort}
          onEdit={itemHandlers.onEdit}
          onDelete={itemHandlers.onDelete}
          onArchive={itemHandlers.onArchive}
          onNavigate={itemHandlers.onNavigate}
        />
      </div>

      <div className="grid gap-4 md:hidden">
        {jobPositions.map((jobPosition) => (
          <JobPositionCard
            key={jobPosition.id}
            jobPosition={jobPosition}
            onEdit={itemHandlers.onEdit}
            onDelete={itemHandlers.onDelete}
            onArchive={itemHandlers.onArchive}
          />
        ))}
      </div>
    </>
  );
}
